export const useDialogControls = (elementId: string) => {
  const { isLocked } = useAppScrollLock();

  const getDialogElement = () => {
    const dialogElement = document.getElementById(elementId);

    if (!dialogElement) {
      throw new Error(`Element with id '${elementId}' hasn't been found`);
    }

    return dialogElement;
  };

  const isShown = (): boolean => {
    return getDialogElement().classList.contains("active");
  };

  const show = (): void => {
    const element = getDialogElement();

    isLocked.value = true;

    element.style.zIndex = "100";
    element.classList.add("active");
    element.style.zIndex = "100";
  };

  const hide = () => {
    const element = getDialogElement();

    isLocked.value = false;

    element.addEventListener(
      "transitionend",
      () => {
        element.style.zIndex = "-100";
      },
      { once: true },
    );

    element.classList.remove("active");
  };

  return { show, hide, isShown, getDialogElement };
};
